import getGlobalFromWindow from '../../helpers/getGlobalFromWindow';
import fetchOptions from '../../helpers/fetchOptions';


export const RECEIVE_ERROR = 'marketplace/errors/RECEIVE_ERROR';
export const CLEAR_ERRORS = 'marketplace/errors/CLEAR_ERRORS';

export const receiveError = function receiveErrorAction(error) {
  const errorMessage = error.message;

  return {
    type: RECEIVE_ERROR,
    error: { message: errorMessage },
  };
};

export const clearErrors = function clearErrorsAction() {
  return {
    type: CLEAR_ERRORS,
  };
};

export const alertError = function alertErrorAction(csrf, message) {
  if (!csrf) {
    return;
  }

  const alertURL = getGlobalFromWindow('alertURL');
  const url = `${alertURL}?csrf_token=${csrf}`;
  const options = fetchOptions('post', { message });

  fetch(url, options).then(() => {});
};
